import { useEffect, useState } from "react";

/** Live result of a media query (true where matchMedia isn't available, e.g. tests and old browsers). */
export function useMedia(query: string): boolean {
  const [match, setMatch] = useState(() => (typeof window === "undefined" || !window.matchMedia ? true : window.matchMedia(query).matches));
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(query);
    const on = () => setMatch(mq.matches);
    on();
    mq.addEventListener?.("change", on);
    return () => mq.removeEventListener?.("change", on);
  }, [query]);
  return match;
}
